 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		72: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		72: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"2":"default-Cart-Menu-OrderStatus-Payments-cart-page-menu-page-orderstatus-page-payment-page","3":"default-cart-page-foodcourt-page-home-page-menu-page-orderstatus-page-payment-page","4":"default-Cart-Menu-cart-page-menu-page","5":"default-Profile-order-history-page-profile-page-userdata-page","6":"default-Menu-cart-page-menu-page","7":"default-OrderStatus-order-summary-page-orderstatus-page","8":"home-page","9":"Menu","10":"OrderStatus","11":"Payments","12":"Paymentsresponse","13":"default-Cart-cart-page","14":"default-FoodCourtCart-cart-page","15":"default-Profile-login-page","16":"default-Profile-profile-page","17":"default-Profile-terms-n-condition-page","18":"default-ScheduledOrder-schedule-order-popup","19":"subDomain","21":"AllOrdersPopUp","22":"AllergiesPopupHome","23":"AskForLocation","24":"Cart","25":"ChangeLanguagePopup","26":"DeleteAllergyPopUp","27":"DiscountAppliedPopUp","28":"DiscountPopUp","29":"DiscountPopUpCartPage","30":"DobPopup","31":"DobSupport","32":"EmailInvoice","33":"EmailPopup","34":"ExitPagePopup","35":"FCCartFooter","36":"FCHeader","37":"FCOrders","38":"FacebookLink","39":"FilterDetails","40":"FoodCourtCart","41":"FoodCourtDetails","42":"FoodcourtCashPopup","43":"FreeDeliveryPromoPopUp","44":"FullPopUp","45":"GoogleLink","46":"GoogleMapPopUp","47":"ItemsNotAvailable","48":"LocationPopUp","49":"LoyaltyPopup","50":"ManualAddress","51":"MenuPopUp","52":"NotesItemPopUp","53":"OrderType","54":"OrderTypePopUp","55":"PackagingChargesPopup","56":"PaymentPopup","57":"Profile","58":"QuickServicesPopup","59":"ReferralInfoPopup","60":"RepeatOrder","61":"ScheduledOrder","62":"ShowNextOpenTimePopUp","63":"StatusPopup","64":"UpdateCartPopup","65":"User","66":"VariantsAddonsPopUp","67":"cart-page","68":"foodcourt-page","69":"foodcourt-restaurant-list","70":"login-page","71":"loyaltyResponsePopup","73":"menu-page","74":"navigatorCantSharePopup","75":"newloaylty-page","76":"order-history-page","77":"order-summary-page","78":"order-type-popup","79":"orderstatus-page","80":"payment-page","81":"privacy-policy-page","82":"profile-page","83":"qrcode-page","84":"restaurant-list","85":"return-page","86":"schedule-order-popup","87":"signup-page","88":"table-change-container","89":"table-change-popup","90":"terms-n-condition-page","91":"userdata-page"}[chunkId]||chunkId) + "." + {"1":"901ac1d1","2":"eb7b0ebf","3":"d3f18d20","4":"01114f79","5":"1239e728","6":"2c8261eb","7":"d33c2dcb","8":"985e2ab8","9":"220f5a9d","10":"14640c7a","11":"72ff2f01","12":"880c3f6d","13":"e1830013","14":"6bc71018","15":"0abbe12f","16":"4520f6f4","17":"b4cf0843","18":"ebe44fbe","19":"0e42f995","20":"f5975520","21":"ae03827f","22":"f16e8bf8","23":"da8586c7","24":"79094032","25":"3b4a525d","26":"a8ea6550","27":"2f502548","28":"f60f6745","29":"955f1e02","30":"d0669e2e","31":"0a7b87c0","32":"d5e0c5ad","33":"e8b21c06","34":"a6d65cd2","35":"fa32103f","36":"66992794","37":"763ae51d","38":"90948371","39":"e7585e70","40":"d027c03a","41":"5cd3dabe","42":"b7aadb79","43":"20f28527","44":"6e43ab97","45":"f9754d8a","46":"82ecc891","47":"f03b4998","48":"c79a852d","49":"b119d3a1","50":"2dde6ba4","51":"6a560fd8","52":"40542a03","53":"da07aee1","54":"c06b8240","55":"b8e9c918","56":"4b4e21a3","57":"c3bb2583","58":"00eb165f","59":"61da0af9","60":"9b7632dd","61":"014fadfe","62":"fb313a63","63":"567bfc09","64":"af46ed9d","65":"522f79ff","66":"f908939e","67":"97b29cba","68":"47fced31","69":"d40d25bc","70":"f6b22c71","71":"361beebf","73":"68e48c26","74":"94978525","75":"cf3864c9","76":"80de3441","77":"bc590016","78":"2e045a96","79":"af3fb8af","80":"ef6de2b3","81":"d645ec2f","82":"52f7abcc","83":"02befef0","84":"d3059f0f","85":"aa399837","86":"a761ed00","87":"1532ac21","88":"9878565e","89":"5181166d","90":"45e88943","91":"2b15c8b9","92":"58121a6b","93":"ee62a882"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"13":1,"15":1,"16":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"27":1,"28":1,"29":1,"32":1,"33":1,"34":1,"39":1,"40":1,"44":1,"46":1,"49":1,"50":1,"51":1,"52":1,"54":1,"57":1,"58":1,"59":1,"60":1,"62":1,"64":1,"65":1,"66":1,"67":1,"68":1,"69":1,"70":1,"73":1,"75":1,"76":1,"77":1,"78":1,"80":1,"82":1,"83":1,"84":1,"86":1,"87":1,"89":1,"91":1,"92":1,"93":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"2":"default-Cart-Menu-OrderStatus-Payments-cart-page-menu-page-orderstatus-page-payment-page","3":"default-cart-page-foodcourt-page-home-page-menu-page-orderstatus-page-payment-page","4":"default-Cart-Menu-cart-page-menu-page","5":"default-Profile-order-history-page-profile-page-userdata-page","6":"default-Menu-cart-page-menu-page","7":"default-OrderStatus-order-summary-page-orderstatus-page","8":"home-page","9":"Menu","10":"OrderStatus","11":"Payments","12":"Paymentsresponse","13":"default-Cart-cart-page","14":"default-FoodCourtCart-cart-page","15":"default-Profile-login-page","16":"default-Profile-profile-page","17":"default-Profile-terms-n-condition-page","18":"default-ScheduledOrder-schedule-order-popup","19":"subDomain","21":"AllOrdersPopUp","22":"AllergiesPopupHome","23":"AskForLocation","24":"Cart","25":"ChangeLanguagePopup","26":"DeleteAllergyPopUp","27":"DiscountAppliedPopUp","28":"DiscountPopUp","29":"DiscountPopUpCartPage","30":"DobPopup","31":"DobSupport","32":"EmailInvoice","33":"EmailPopup","34":"ExitPagePopup","35":"FCCartFooter","36":"FCHeader","37":"FCOrders","38":"FacebookLink","39":"FilterDetails","40":"FoodCourtCart","41":"FoodCourtDetails","42":"FoodcourtCashPopup","43":"FreeDeliveryPromoPopUp","44":"FullPopUp","45":"GoogleLink","46":"GoogleMapPopUp","47":"ItemsNotAvailable","48":"LocationPopUp","49":"LoyaltyPopup","50":"ManualAddress","51":"MenuPopUp","52":"NotesItemPopUp","53":"OrderType","54":"OrderTypePopUp","55":"PackagingChargesPopup","56":"PaymentPopup","57":"Profile","58":"QuickServicesPopup","59":"ReferralInfoPopup","60":"RepeatOrder","61":"ScheduledOrder","62":"ShowNextOpenTimePopUp","63":"StatusPopup","64":"UpdateCartPopup","65":"User","66":"VariantsAddonsPopUp","67":"cart-page","68":"foodcourt-page","69":"foodcourt-restaurant-list","70":"login-page","71":"loyaltyResponsePopup","73":"menu-page","74":"navigatorCantSharePopup","75":"newloaylty-page","76":"order-history-page","77":"order-summary-page","78":"order-type-popup","79":"orderstatus-page","80":"payment-page","81":"privacy-policy-page","82":"profile-page","83":"qrcode-page","84":"restaurant-list","85":"return-page","86":"schedule-order-popup","87":"signup-page","88":"table-change-container","89":"table-change-popup","90":"terms-n-condition-page","91":"userdata-page"}[chunkId]||chunkId) + "." + {"1":"31d6cfe0","2":"c3592dc5","3":"45e8f9a7","4":"bfc60e7d","5":"e42af7af","6":"18886a6c","7":"c137e511","8":"9ab2f550","9":"5606d5c5","10":"07932d58","11":"2e545bbd","12":"31d6cfe0","13":"be8bba51","14":"31d6cfe0","15":"5e8d4925","16":"00652bfa","17":"31d6cfe0","18":"579b83b8","19":"2fbb6fc6","20":"196acba4","21":"727ce616","22":"fed9b492","23":"b60a6ce9","24":"7c8608c4","25":"e2826941","26":"31d6cfe0","27":"96f878d3","28":"96f878d3","29":"0af3d544","30":"31d6cfe0","31":"31d6cfe0","32":"cc78a300","33":"cc78a300","34":"96f878d3","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"07897893","40":"c033b784","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"96f878d3","45":"31d6cfe0","46":"5448acf8","47":"31d6cfe0","48":"31d6cfe0","49":"4f3ff44b","50":"ffd033a0","51":"96f878d3","52":"f1a5887a","53":"31d6cfe0","54":"ea0013a3","55":"31d6cfe0","56":"31d6cfe0","57":"94f72861","58":"9085a837","59":"4f3ff44b","60":"96f878d3","61":"31d6cfe0","62":"96f878d3","63":"31d6cfe0","64":"96f878d3","65":"4b50e10b","66":"cfef31fc","67":"07781a91","68":"4b50e10b","69":"37bcca3e","70":"42413be9","71":"31d6cfe0","73":"e5ff1b92","74":"31d6cfe0","75":"c7ffcda3","76":"bad11f75","77":"c2bce70d","78":"6c114334","79":"31d6cfe0","80":"642c8ca9","81":"31d6cfe0","82":"45e8f9a7","83":"3e2aaca5","84":"00652bfa","85":"31d6cfe0","86":"6ce75474","87":"ec8f8df1","88":"31d6cfe0","89":"96f878d3","90":"31d6cfe0","91":"ac6c49e7","92":"b80c4254","93":"fb22ce49"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpreact_user_app"] = this["webpackJsonpreact_user_app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([196,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
